import { NewsCard } from "../common";
import { STATIC_NEWS } from "../../data/staticSiteContent";
import { Fade } from "react-awesome-reveal";

export default function NewsScreen() {
  const newsList = STATIC_NEWS;

  return (
    <div className=" bg-neutral-900 py-16 md:py-24 px-6">
      <div className="container mx-auto">
        {newsList.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 py-5">
            <Fade direction="up" triggerOnce>
              {newsList.map((item) => {
                return <NewsCard key={item._id} data={item} />;
              })}
            </Fade>
          </div>
        ) : (
          <p className="text-center">No news found!</p>
        )}
      </div>
    </div>
  );
}
